export const UPLOAD_SETTINGS_NETWORK_TITLE: string = 'Add settings networks';
export const UPLOAD_SETTINGS_NETWORK_DESCRIPTION: string = 'Provide an excel file (.xlsx) for the Network settings.';
export const UPLOAD_SETTINGS_NETWORK_SUCCESSFULLY: string = 'Settings Network successfully upload';
export const UPLOAD_SETTINGS_NETWORK_SUBMIT_TEXT: string = 'Upload';
export const UPLOAD_SETTINGS_NETWORK_KEY: string = 'upload-settings-networks';
